import { http, isCryptoEnv } from '@/utils/http'
import type { Response, PageRequest, PageResponse } from '@/types/http'
import {
  CustomerType,
  type CustomerServiceDTO,
  type FeedbackRecordDTO,
  type FeedbackTypeDTO
} from '@/types/service'

/**
 * 查询客服列表
 */
export const getCustomerServiceList = async (customerType: CustomerType) => {
  return http<PageResponse<CustomerServiceDTO>>(
    `/app-api/member/customer/service/list/${customerType}`,
    {
      method: 'POST',
      body: {}
    }
  ).then((res) => res.data?.records || [])
}

/**
 * 查询反馈列表
 */
export const getFeedbackList = async (params: PageRequest) => {
  return http<PageResponse<FeedbackRecordDTO>>('/app-api/member/feedback/list', {
    method: 'POST',
    body: params
  })
}

/**
 * 获取反馈类型列表
 */
export const getFeedbackTypes = async () => {
  return http<Response<FeedbackTypeDTO[]>>('/app-api/member/feedback/type', {
    method: 'POST'
  })
}

/**
 * 获取反馈详情
 */
export const getFeedbackDetail = async (id: number) => {
  return http<Response<FeedbackRecordDTO>>('/app-api/member/feedback/detail', {
    method: 'POST',
    body: { id }
  })
}

/**
 * 删除反馈
 */
export const deleteFeedback = async (id: number) => {
  return http<Response<boolean>>('/app-api/member/feedback/delete', {
    method: 'POST',
    body: { id }
  })
}

/**
 * 添加反馈
 */
export const addFeedback = async (data: {
  questionType: number
  content: string
  fileUrl?: string[]
}) => {
  return http<Response<boolean>>('/app-api/member/feedback/add', {
    method: 'POST',
    body: data
  })
}

/**
 * 上传文件
 */
export const uploadFile = async (file: File, onProgress?: (progress: number) => void) => {
  const formData = new FormData()
  formData.append('file', file)

  return http<Response<string>>('/app-api/infra/file/upload', {
    method: 'POST',
    body: formData,
    onUploadProgress: (progressEvent) => {
      if (onProgress && progressEvent.total) {
        const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
        onProgress(progress)
      }
    }
  })
}

/**
 * 上传图片
 * @param formData FormData 对象，需包含 'file' 和 'path' 字段
 * @param onProgress 上传进度回调函数
 */
export const uploadImage = async (formData: FormData, onProgress?: (progress: number) => void) => {
  const file = formData.get('file') as File
  const buffer = await file.arrayBuffer()
  const bytes = new Uint8Array(buffer)

  if (!file) {
    throw new Error('File not found in FormData')
  }

  return await http<Response<string>>('/app-api/account/file/uploadImage', {
    method: 'post',
    body: isCryptoEnv ? bytes : file,
    onProgress
  })
}
